/**
 * 极睿科技 Infimind 官网内容数据源
 * 基于原站渲染 DOM 逐字段还原
 */

export const nav = {
  logoText: "易键科技",
  logoImg: "/assets/2.png",
  links: [
    { label: "首页", id: "home" },
    { label: "产品介绍", id: "products" },
    // { label: '解决方案', id: 'solutions' },
    // { label: '客户案例', id: 'cases' },
    { label: "关于我们", id: "about" },
  ],
  cta: "预约演示",
  menuBg: "/assets/menu-decoration-DF3yOe-W.webp",
  productMenu: [
    {
      // title: "内容生成",
      items: [
        {
          title: "AI 矩阵营销智能体",
          desc: "1个人管理100+小红书/抖音/视频号/快手四大主流平台矩阵账号，一键批量生成和智能发布1000+去重优质爆款图文和短视频内容，撬动百万级自然流量。",
          icon: "image",
          color: "text-cyan-500",
        },
        {
          title: "AI 精准获客智能体",
          desc: "7×24全域不间断矩阵搜索竞品图文、短视频和直播间内容，在互联网沉淀的海量的用户数据信息池中，自动高效快速挖掘和抓取精准客资。",
          icon: "wand-sparkles",
          color: "text-purple-500",
        },
      ],
    },
    {
      // title: "内容美化加工",
      items: [
        {
          title: "AI 销售客服智能体",
          desc: "企业专属知识库+AI销售客服智能体，从被动应答到主动销售，打造7x24小时超级销售顾问和客服，实现全自动智能回复。",
          icon: "image-plus",
          color: "text-blue-500",
        },
        {
          title: "AI 私域运营智能体",
          desc: "AI全面接管N个微信号，基于知识库自动加好友、自动回复、自动发朋友圈、自动SOP跟进，全自动运营私域。",
          icon: "video",
          color: "text-indigo-500",
        },
        // {
        //   title: "iCut 直剪",
        //   desc: "直播切片智能制作与发布",
        //   icon: "scissors",
        //   color: "text-emerald-500",
        // },
      ],
    },
    {
      // title: "端到端服务",
      items: [
        {
          title: "AI GEO优化服务",
          desc: "通过优化在AI大模型平台（如豆包、DeepSeek等）上的内容展示与引用，让企业的品牌、产品、服务信息能够被AI模型智能识别、理解并推荐给用户。",
          icon: "factory",
          color: "text-slate-600",
        },
      ],
    },
  ],
};

export const hero = {
  badge: "全链路AI数字营销获客智能体",
  scenes: [
    {
      key: "商拍",
      tab: "AI 矩阵营销智能体",
      title: ["AI ", "矩阵营销智能体"],
      desc: "管理100+矩阵账号，AI一键拆解和复刻爆款短视频和图文笔记，运营成本降低80%+，效率提升50倍以上。",
    },
    {
      key: "创作",
      tab: "AI 精准获客智能体",
      title: ["AI ", "精准获客智能体"],
      desc: "AI 7×24小时全域不间断矩阵搜索竞品短视频/直播间/图文内容，自动高效挖掘和触达精准客资，客资线索成本＜0.01元/条。",
    },
    {
      key: "分发",
      tab: "AI 销售客服智能体",
      title: ["AI ", "销售客服智能体"],
      desc: "构建企业级专属知识库大脑，打造7x24小时超级销售顾问和客服，实现AI全自动智能回复，大幅提升销售线索转化。",
    },
    {
      key: "增长",
      tab: "AI 私域运营智能体",
      title: ["AI ", "私域运营智能体"],
      desc: "7*24小时AI自动接管微信号，全自动运营私域，增加客户粘性和复购，让私域存量客户持续变现，打造长效客户生态。",
    },
    {
      key: "资产",
      tab: "AI GEO优化服务",
      title: ["AI ", "GEO优化服务"],
      desc: "通过优化在AI大模型平台（如豆包、 DeepSeek等）上的内容展示与引用，让企业的品牌、产品、服务信息能够被AI模型智能识别、理解并推荐给用户。",
    },
  ],
  cta: "预约演示",
  modelImg: "/assets/product1.png",
  modelImg2: "/assets/product2.png",
  modelImg3: "/assets/product3.png",
  modelImg4: "/assets/product4.png",
  modelImg5: "/assets/product5.png",
};

export const brandMarquee = {
  title: "赋能全球领先品牌",
  brands: [
    "ANTA",
    "EP YAYING",
    "DESCENTE",
    "EIFINI",
    "EXCEPTION",
    "EEKA",
    "MO&Co.",
    "ELLASSAY",
    "JOEONE",
    "SNOW FLYING",
    "FAIRWHALE",
    "YISHION",
    "ICICLE",
    "CHIU SHUI",
    "ANNIL",
    "BALENO",
    "BOSSINI",
    "LA CHAPELLE",
    "BELLE",
    "PIONEER CAMP",
  ],
};

export const products = {
  eyebrow: "产品服务介绍",
  rows: [
    {
      key: "shengcheng",
      // category: "内容生成",
      layout: "studio",
      // tabs: ["AGI Ecpro", "Video AI"],
      title: "AI智能体系统产品",
      desc: "内容生产→公域获客→销售转化→私域运营”完整业务闭环的一站式全链路AI数字营销获客智能体系统。将复杂的营销流程简化为标准化的自动化流程，真正实现从“流量获取”到“成交转化”的无缝衔接与指数级增长。",
      cta: "立即咨询",
      img: "/assets/product6.png",
    },
    {
      key: "meihua",
      // category: "内容美化加工",
      layout: "studio",
      // tabs: ["ECPro 易尚货", "iClip 易视频", "iCut 直剪"],
      title: "AI增值陪跑服务",
      desc: "帮助企业跨越从“会用工具”到“用好工具”的认知鸿沟。通过系统性内训，确保AI系统在您的业务土壤中生根发芽，真正将冰冷的软件操作转化为可量化的团队战斗力与运营能力的持续进化。",
      cta: "立即咨询",
      img: "/assets/product7.png",
      // imgA: "/assets/showcase-clothing-2-BFt6NMKQ.png",
      // imgB: "/assets/showcase-clothing-3-BG5qy8Fd.png",
    },
    {
      key: "fuwu",
      // category: "端到端服务",
      layout: "studio",
      // tabs: ["图文代运营", "视频代运营", "KOC种草"],
      title: "AI增长联营服务",
      desc: "以“增长合伙人”身份与客户深度绑定的战略级合作。我们派出专业的AI运营团队，全面接管您的矩阵账号管理、AI内容批量生产与分发、精准获客触达等全链路执行工作，以“增量营收/利润分成”实现利益捆绑。",
      cta: "立即咨询",
      img: "/assets/product8.png",
      // imgs: [
      //   "/assets/showcase-detail-BshTZJ72.png",
      //   "/assets/showcase-selling-point-DR1m-mCz.png",
      //   "/assets/showcase-lifestyle-T7PNSljz.png",
      //   "/assets/showcase-shoe-1-QnX2yCm0.png",
      //   "/assets/showcase-shoe-2-B47aYBFL.png",
      // ],
    },
    {
      key: "shengcheng",
      // category: "内容生成",
      layout: "studio",
      // tabs: ["AGI Ecpro", "Video AI"],
      title: "AI智能体定制化开发",
      desc: "为企业提供从0到1的全栈式技术赋能。通过定制化开发，为客户提供一颗完全适配企业基因、安全可控、可随业务持续进化的“专属AI大脑”，真正实现技术与业务的完美交融，构筑企业坚不可摧的数字壁垒。",
      cta: "立即咨询",
      img: "/assets/product9.png",
    },
  ],
};

export const solutions = {
  eyebrow: "解决方案",
  title: "AI 驱动的全链路数字化解决方案",
  sub: "基于强大的 AI 工具生态，为不同发展阶段的电商业务提供定制化增长方案",
  cards: [
    {
      no: "01",
      title: "货架电商品牌",
      desc: "帮助品牌实现从拍摄，美工，排版上新于后续种草的一站式服务",
      tools: ["AGI ECPro", "INFIMIND Video", "ECPRo", "AI矩阵分发"],
      grad: "from-blue-500 to-cyan-400",
    },
    {
      no: "02",
      title: "直播短视频电商品牌",
      desc: "不论短视频还是直播为主的品牌都可以高效实现内容的覆盖",
      tools: ["iCut", "iClip", "INFIMIND Video"],
      grad: "from-purple-500 to-indigo-400",
    },
    {
      no: "03",
      title: "海外电商大卖",
      desc: "对接TikTok等平台，帮助生成海量优质内容，无需海外模特，可以图文短视频覆盖",
      tools: ["AGI ECPro", "INFIMIND Video", "AI矩阵分发"],
      grad: "from-pink-500 to-rose-400",
    },
    {
      no: "04",
      title: "MCN机构与达人",
      desc: "直播间高效管理，低成本覆盖短视频内容，通过AI技术提升分发效率",
      tools: ["INFIMIND Video", "iCut", "iClip"],
      grad: "from-orange-500 to-amber-400",
    },
    {
      no: "05",
      title: "代运营机构",
      desc: "不论TP还是DP，都可以进一步降低品牌代运营的成本，提升交付质量",
      tools: [
        "AGI ECPro",
        "INFIMIND Video",
        "ECPRo",
        "AI矩阵分发",
        "iCut",
        "iClip",
      ],
      grad: "from-emerald-500 to-teal-400",
    },
    {
      no: "06",
      title: "无货源/档口商家",
      desc: "助力每一个想做电商的普通个体，让开店和做内容变得不再困难",
      tools: ["短视频带货Agent", "AGI ECPro", "INFIMIND Video"],
      grad: "from-violet-500 to-fuchsia-400",
    },
  ],
};

export const capabilities = {
  eyebrow: "领先的 AI 核心能力",
  title: "领先的 AI 核心能力",
  items: [
    {
      value: "100M+",
      label: "多模态数据库",
      desc: "深度覆盖服装、美妆、快消等全品类商业物料。",
    },
    {
      value: "99.2%",
      label: "识别准确率",
      desc: "精准捕捉面料纹理、廓形与品牌视觉风格。",
    },
    {
      value: "3s",
      label: "极速生成",
      desc: "分布式算力架构，支持高并发、秒级内容生成。",
    },
    {
      value: "100%",
      label: "版权安全",
      desc: "原创生成的商业模型，为品牌提供合规保障。",
    },
  ],
};

export const cases = {
  eyebrow: "客户案例",
  title: "各行各业的先进企业都在用 Infimind",
  more: "查看更多同行案例",
  list: [
    {
      sector: "运动服饰",
      brand: "ANTA",
      brandColor: "text-red-600",
      quote:
        "Infimind 帮我们实现了全链路内容的自动化，从商拍到分发，以前需要一周的 campaign，现在两天就能上线，效率提升惊人。",
      person: "张伟",
      role: "安踏品牌数字营销总监",
      img: "https://images.unsplash.com/photo-1483721310020-03333e577078?q=80&w=800&auto=format&fit=crop",
      avatar: "https://i.pravatar.cc/150?u=1",
      stats: [
        { value: "40+", label: "生成效率提升倍数" },
        { value: "70%", label: "拍摄成本降低" },
      ],
    },
    {
      sector: "新势力汽车",
      brand: "Li Auto",
      brandColor: "text-slate-900",
      quote:
        "RIDGE 模型不仅是工具，更是我们的增长伙伴。它对用户情绪的精准捕捉，让我们的每一条视频都能精准触达潜客。",
      person: "李想",
      role: "理想汽车 品牌市场部 VP",
      img: "https://images.unsplash.com/photo-1617788138017-80ad40651399?q=80&w=800&auto=format&fit=crop",
      avatar: "https://i.pravatar.cc/150?u=2",
      stats: [
        { value: "153", label: "覆盖全国门店" },
        { value: "99%", label: "品牌一致性" },
      ],
    },
    {
      sector: "快消饮品",
      brand: "Genki",
      brandColor: "text-black",
      quote:
        "Infimind 是一款有灵魂的好产品。它理解我们的元气美学，自动生成的物料既保留了品牌调性，又极具社交传播力。",
      person: "唐彬森",
      role: "元气森林 创始人",
      img: "https://images.unsplash.com/photo-1622483767028-3f66f32aef97?q=80&w=800&auto=format&fit=crop",
      avatar: "https://i.pravatar.cc/150?u=3",
      stats: [
        { value: "83%", label: "CTR 点击率提升" },
        { value: "100%", label: "全渠道覆盖" },
      ],
    },
    {
      sector: "连锁酒店",
      brand: "Huazhu",
      brandColor: "text-blue-700",
      quote:
        "我相信 AI 改变行业的时刻已经到来。Infimind 让我们成千上万家门店的私域运营变得标准化、智能化。",
      person: "刘欣欣",
      role: "华住集团 首席数字官",
      img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=800&auto=format&fit=crop",
      avatar: "https://i.pravatar.cc/150?u=4",
      stats: [
        { value: "44", label: "分钟/张 出图速度提升" },
        { value: "70%", label: "自有应用渗透" },
      ],
    },
  ],
};

export const clients = {
  eyebrow: "合作客户",
  title: "合作客户",
  introLead: "已为",
  statBrand: "3000+",
  introMid: "品牌",
  statShop: "5万+",
  introTail: "店铺提供 AI 生产力支持，共创内容生产新范式",
  rowA: [
    "安踏",
    "EP雅莹",
    "DESCENTE",
    "伊芙丽",
    "例外",
    "赢家时尚",
    "MO&Co",
    "ELLASSAY",
    "九牧王",
    "雪中飞",
  ],
  rowB: [
    "马克华菲",
    "以纯",
    "艾莱依",
    "秋水伊人",
    "安奈儿",
    "班尼路",
    "堡狮龙",
    "拉夏贝尔",
    "百武西",
    "拓路者",
  ],
};

export const cta = {
  lead: "准备好开启",
  highlight: "AI 驱动的增长",
  tail: "了吗？",
  desc: "立即预约专家演示，获取定制化全链路内容解决方案",
  btn: "预约演示",
};

export const footer = {
  // links: [
  //   {
  //     title: "友情链接",
  //     items: ["AGI Ecpro", "易尚货", "iClip易视频", "iCut 直剪", "SmartCut"],
  //   },
  //   {
  //     title: "办公地址",
  //     items: [
  //       "总部地址: 北京市朝阳区酒仙桥路66号保利广场东座208",
  //       "华东大区: 杭州市萧山区润奥商务中心T2写字楼5A02",
  //       "华南大区: 广州市天河区越秀金融大厦65层",
  //     ],
  //   },
  //   {
  //     title: "服务与支持",
  //     items: [
  //       "媒体合作: pr@infimind.com",
  //       "商务合作: liwei@infimind.com",
  //       "工作时间: 10:00-19:00（工作日）",
  //     ],
  //   },
  //   { title: "联系我们", items: ["客服电话1: 13605159903"] },
  // ],
  // qrcode: "/assets/qrcode-DmfYuDtT.jpg",
  copyright:
    "Copyright © www.elinkai.net, All Rights Reserved. 海南易键国际科技有限公司",
  icp: "琼ICP备2025055393号-3",
};

export const about = {
  // 关于极睿
  hero: {
    title: "关于易键科技",
    titleSub: "eLink AI",
    p1: "易键科技eLink AI是清华启迪孵化培育的AI智能体科技公司，致力于打造全球领先的全链路AI数字营销获客智能体。凭借着领先的AI大模型技术能力、海量的电商、本地生活、自媒体等行业数据，为企业/商家和自媒体从业者提供集AI爆款短视频和图文数字内容创作智能体、AI矩阵营销智能体、AI精准获客智能体、AI销售客服智能体、AI私域运营智能体、AI GEO优化服务等于一体的全链路运营解决方案。",
    // p2: '为企业提供集虚拟拍摄、图文制作排版、商品短视频制作分享于一体的全链路内容运营解决方案，赋能电商企业以更高效、更优质的内容驱动业务增长。',
    // stats: [
    //   { value: '2017', label: '成立年份' },
    //   { value: '1000+', label: '服务品牌' },
    //   { value: 'B轮', label: '融资阶段' }
    // ],
    img: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=2070",
    badgeChar: "清",
    badgeTitle: "核心团队",
    badgeSub: "源自清华大学计算机系",
    quote: "凭借领先的AIGC技术能力，让每一张图片、每一段视频都充满商业智慧。",
  },

  // RIDGE 山脉模型
  // ridge: {
  //   title: 'RIDGE 山脉模型',
  //   desc: '基于 RIDGE 架构，构建从资产数字化到增长闭环的生成式商业引擎。',
  //   label: 'Intelligence Core',
  //   big: 'RIDGE',
  //   framework: 'The Framework for Content ROI',
  //   quote: ['以 RIDGE 模型为核心，', '在流动的资产间，', '捕获品牌', '增长奇点', '。'],
  //   version: 'Global Ops v4.0',
  //   cardBadge: 'Active Agent Cluster',
  //   cardTitle: 'Generative Enterprise Agent',
  //   cardDesc: '企业级内容智能体集群，在 RIDGE 架构下驱动从数字资产到商业价值的无缝进化。',
  //   letters: [
  //     { letter: 'R', en: 'Revenue', zh: '营销收入', desc: '行业唯一以收入增长为最终目标和考核方向的 Agent', grad: 'from-amber-400/20 via-orange-500/10 to-transparent' },
  //     { letter: 'I', en: 'Insight', zh: '市场洞察', desc: '基于海量爆款数据分析，提供品牌营销策略', grad: 'from-emerald-400/20 via-teal-500/10 to-transparent' },
  //     { letter: 'D', en: 'Distribution', zh: '多平台分发', desc: '对接国内多平台展示能力，实现全渠道覆盖', grad: 'from-blue-400/20 via-indigo-500/10 to-transparent' },
  //     { letter: 'G', en: 'Generative', zh: '创意生成', desc: '商品内容与种草内容生成，覆盖拍摄美化与剪辑', grad: 'from-purple-400/20 via-pink-500/10 to-transparent' },
  //     { letter: 'E', en: 'Expansion', zh: '扩张增长', desc: '用内容带来品牌的收入和声量指数级双重增长', grad: 'from-rose-400/20 via-red-500/10 to-transparent' }
  //   ]
  // },

  // 核心团队成员
  // team: {
  //   title: '核心团队成员',
  //   desc: '由清华大学计算机系领衔，汇聚全球AI领域的精英人才。',
  //   members: [
  //     { name: '武彬', role: '创始人兼CEO', desc: '创始人兼CEO，清华大学计算机系本科、人工智能实验室硕士，辅修大数据研究中心优秀毕业生，在校期间多次参与973、863重点项目。北京U30 杰出青年、工信部中小企业领军人才计划、2019福布斯中国U30精英，2020福布斯亚洲U30精英。', img: '/assets/team-wubin-D9d-2C1R.png' },
  //     { name: '徐镇', role: '联合创始人兼CTO', desc: '联合创始人兼CTO，清华大学计算机系本科，网络所硕士。曾就职于解放军第56研究所从事并行分布处理与智能计算机相关研究工作，随团队获得军队科技成果二等奖；多年电商大数据和人工智能相关工作经验。', img: '/assets/team-xuzhen-CuyWUXSI.png' },
  //     { name: '纵宙', role: '销售VP', desc: '销售VP，曾就职于百度、万达等企业，深耕线上线下业务，多年销售、运营大型团队管理经验。', img: '/assets/team-zongzhou-B1cTWxj-.png' }
  //   ]
  // },

  // 战略合作伙伴
  partners: {
    eyebrow: "Strategic Partners",
    title: "战略合作伙伴",
    list: [
      "清华大学",
      "MIT",
      "英伟达",
      "Google",
      "Anthropic",
      "Open AI",
      "xAI",
      "MinMax",
      "阿里云",
      "华为",
      "火山引擎",
      "智谱 AI",
      "KIMI",
      "可灵",
      "Deepseek",
      "清华 X 空间",
      "抖音",
      "小红书",
      "视频号",
      "快手",
      "世纪互联",
      "寒武纪",
      "兆易创新",
      "中集",
      "怡亚通",
      "商界",
      "盈科",
      "金种籽",
      "政启网",
      "邻莱国际",
    ],
  },

  // 极睿大事记
  // timeline: {
  //   title: '极睿大事记',
  //   desc: '深耕 AIGC 领域多年，每一步都见证了行业的技术革新。',
  //   years: [
  //     { year: '2025', items: ['AIGC 全自动内容工坊正式上线', '开启全球化品牌服务战略', '深度融合多模态垂直大模型'] },
  //     { year: '2024', items: ['顺利完成 C 轮融资', '推出实时 AI 虚拟直播解决方案', '荣获年度 AIGC 商业化创新大奖'] },
  //     { year: '2023', items: ['3月 iCut引擎上线', '5月 iClip易视频发布', '8月 PhotoMagic AI自拍上线', 'AI MCN带货服务全面开启'] },
  //     { year: '2022', items: ['顺利完成B轮融资', '4月 ECPro手机制作服务上线', '内容代制作板块签约维特', 'AiFashion客单突破50w'] },
  //     { year: '2021', items: ['12月 ECPro正式版3.0发布', '商业化：ECPro供应商群平台类型客户首单', '全链路自动化引擎打通'] },
  //     { year: '2020', items: ['红衫资本A轮融资', '发布IPIM 3.0系统', '首创属性识别自动化识别等功能'] },
  //     { year: '2019', items: ['完成 Pre-A 轮融资', '推出 IPIM 2.0 智能图像识别系统', '签约首批 Top 100 电商大客户'] },
  //     { year: '2018', items: ['获得天使轮融资', '核心算法入选 NVIDIA 初创加速计划', '首款 AI 属性识别引擎发布'] },
  //     { year: '2017', items: ['极睿科技在北京正式成立', '创始团队核心成员源自清华大学计算机系', '确立 AI 赋能电商内容的愿景'] }
  //   ]
  // },

  // 荣誉见证
  // honors: {
  //   badge: 'Recognition & Awards',
  //   title: ['实至名归，', '荣誉见证', '实力。'],
  //   desc: '极睿科技在技术创新、商业实践和行业影响力等方面持续突破，获得了来自学术界、工业界及资本市场的广泛认可。',
  //   statNum: '50+',
  //   statText: '权威机构共同认证',
  //   imgs: ['/assets/honor-1-CpfrVCq3.png', '/assets/honor-2-SmVF_jWY.png', '/assets/honor-3-CRoarthk.png'],
  //   cards: [
  //     { year: '2022', title: '荣获2018年度最具投资价值创业公司TOP20' },
  //     { year: '2023', title: '阿里巴巴内容工具唯一五星服务商' },
  //     { year: '2024', title: 'AIGC最具商业化价值奖最具影响力奖' },
  //     { year: '2025', title: '被商务厅评选为AI电商跨境电商应用冠军' }
  //   ]
  // }
};
